import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { ConfigurationManager } from 'shell/utils/config';
import { request } from 'shell/utils/request';

/**
 * Encapsulates configuration data loading an passing it to children components
 * Should be placed at the top of level App components tree and rendered only once
 *
 * @param {String} configUrl
 * @param children
 * @returns {null|*}
 * @constructor
 */
export const ConfigurationLoader = ({ configUrl, children }) => {
  const [config, setConfig] = React.useState(null);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    if (!config) {
      // load Config data
      request(configUrl)
        .then((response) => {
          if (!response.data) {
            const error = new Error('Failed to load Configuration data');
            error.status = 400;

            setError(error);
            return;
          }

          setConfig(new ConfigurationManager(response.data));
        })
        .catch((err) => setError(err.response));
    }
  }, [config]);

  if (config) {
    return children(config);
  }

  if (error) {
    if (error.status >= 500) {
      return (
        <Fragment>
          <h1>Internal Server Error</h1>
          <p>While attempting to load configuration data</p>
        </Fragment>
      );
    }

    if (error.status >= 400) {
      return <h1>Failed to load Configuration data</h1>;
    }
  }

  return null;
};

ConfigurationLoader.propTypes = {
  children: PropTypes.func.isRequired,
  configUrl: PropTypes.string,
};

ConfigurationLoader.defaultProps = {
  configUrl: '/static/config.json',
};

export default ConfigurationLoader;
